



























































import Vue from 'vue';
import { mapGetters } from 'vuex';
import RedMatOptionsDTO from './RedMatOptionsDTO';
import {
  SET_OPTIONS,
  CALCULATE_REQUEST,
  DECREMENT_EDIT_STEP,
  IS_LOADING,
} from './RedMatCalculationModule';
import { RED_MAT_CALCULATION_RESULTS } from '../../router/route-names';

export default Vue.extend({
  name: 'SubmitOptions',
  data() {
    return {
      options: new RedMatOptionsDTO(),
      topologyFile: null as File | null,
      trajectoryFile: null as File | null,
    };
  },
  computed: {
    ...mapGetters({
      isLoading: IS_LOADING,
    }),
  },
  methods: {
    onClickPrevious() {
      this.$store.dispatch(DECREMENT_EDIT_STEP);
    },
    onClickSubmit() {
      this.$store.dispatch(SET_OPTIONS, this.options)
        .then(() => this.$store.dispatch(CALCULATE_REQUEST))
        .then(() => {
          this.$router.push({
            name: RED_MAT_CALCULATION_RESULTS,
          });
        })
        .catch(() => {
          // do nothing
        });
    },
  },
});
